// Shared config for the Treatments feature. Shot-list rules are in treatmentShots.js.

/** "58s", "1m 04s" - for running times, which are seconds. */
export function formatRunningTime(seconds) {
  const total = Math.round(Number(seconds) || 0);
  if (total < 60) return `${total}s`;
  const m = Math.floor(total / 60);
  const s = String(total % 60).padStart(2, '0');
  return `${m}m ${s}s`;
}
